window.o_global = window.o_global || {};

window.o_global.helper = window.o_global.helper || {};

(function () {
  /**
   * Sets up Events for textExpander100-pattern and message100 pattern
   */
  function initClickListeners() {
    document.addEventListener("click", function (event) {
      const { target } = event;

      // Sets up Events for message100-pattern
      if (target.classList.contains("js_message__close")) {
        const message = window.o_util.dom.getParentByClassName(target, "p_message");

        if (message) {
          message.style.display = "none";
        }
      }
    });
  }

  window.o_global.eventLoader.onReady(10, initClickListeners);
})();
